import { render, staticRenderFns } from "./StockTemplate.vue?vue&type=template&id=50e3a234&scoped=true"
import script from "./StockTemplate.vue?vue&type=script&lang=js"
export * from "./StockTemplate.vue?vue&type=script&lang=js"
import style0 from "./StockTemplate.vue?vue&type=style&index=0&id=50e3a234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e3a234",
  null
  
)

export default component.exports